import { Component, ElementRef, OnInit, inject, viewChild, signal } from "@angular/core";
import { UntypedFormBuilder, Validators, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { Blog } from '../../../models/blog';
import { Works } from '../../../models/works';
import { FormControl } from '@angular/forms';
import { WorksService } from '../../../services/works.service';
import { ComuniService } from '../../../services/comuni.service';

import { MessageService, SelectItem } from "primeng/api";
import * as moment from 'moment';
import { Comuni } from 'src/app/models/comuni';
import { Locations } from 'src/app/models/locations';
import { LocationsService } from 'src/app/services/locations.service';
import { Location } from '@angular/common';
import { Bind } from 'primeng/bind';
import { Card } from 'primeng/card';
import { ButtonDirective } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { TranslatePipe } from '@ngx-translate/core';

import { TPipe } from "../../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: 'app-locations-form',
    templateUrl: './locations-form.component.html',
    imports: [TPipe, FormsModule, ReactiveFormsModule, Bind, Card, ButtonDirective, InputText, TranslatePipe]
})
export class LocationsFormComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private comuniService = inject(ComuniService);
  private locationsService = inject(LocationsService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private messageService = inject(MessageService);
  private _location = inject(Location);

  readonly myInputVariable = viewChild<ElementRef>("myInput");

  readonly pageTitle = signal<string>(undefined);
  readonly error = signal<string>(undefined);
  readonly uploadError = signal<string>(undefined);
  imagePath: any;
  locations: Locations;
  location: Locations;

  checked: boolean = true;
  selectedValue: string;

  categoryForm: UntypedFormGroup;

  cities: Blog[];
  format1: string = "";
  format2: string = "";
  selectedCity: Blog;
  selectedWorks: Works;
  readonly selectedDate = signal<Date>(undefined);
  date: Date;
  readonly currentUser = signal<any>(undefined);

  constructor() {
    if (this.date) {
      this.selectedDate.set(new Date(this.date));
    }
    this.currentUser.set(JSON.parse(localStorage.getItem('currentUser') || '[]'));

  }

  ngOnInit() {

    const id = this.route.snapshot.paramMap.get('id');
    if (id) {

      this.pageTitle.set('Luogo lavorazione');
      this.locationsService.getId(id).subscribe(
        res => {
          this.categoryForm.patchValue({
            name: res.name,
            description: res.description,
            user_id: this.currentUser().user_id,
            id: res.id
          });

        }
      );
    } else {
      this.pageTitle.set('Crea Luogo lavorazione');
    }

    this.categoryForm = this.fb.group({
      id: [''],
      name: ['', Validators.required],
      description: [''],
      user_id: [this.currentUser().user_id]

    });
  }

  get name() {
    return this.categoryForm.get('name');
    return this.categoryForm.get('description');

  }

  onSubmit() {

    const formData = new FormData();

    formData.append('name', this.categoryForm.get('name').value);
    formData.append('description', this.categoryForm.get('description').value);
    formData.append('user_id', this.categoryForm.get('user_id').value);

    const id = this.categoryForm.get('id').value;

    if (id) {
      this.locationsService.update(formData, id).subscribe(
        res => {
          if (res.status == 'error') {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Attenzione', detail: 'Salvato con sucesso' });
            this._location.back();
          }
        },
        error => this.error.set(error)
      );
    } else {
      this.locationsService.create(formData).subscribe(
        res => {
          if (res.status === 'error') {
            this.uploadError.set(res.message);
          } else {
            this._location.back();
          }
        },
        error => this.error.set(error)
      );
    }

  }

}
